export default __webpack_public_path__ + "static/media/darkModeConvert.c7c15f7b.png";